<template>
    <LinkHover :type="type" :to="to" :class="['cta', 'is-dir-' + direction]">
        <span
            class="default"
            :style="getStyle('default')"
        >
            <component :is="icon" v-if="direction !== 'none'" :direction="direction" :color="getColor('default', 'color')"/><slot/>
        </span>
        <template v-slot:hover>
            <span
                class="hover"
                :style="getStyle('hover')"
            >
                <component :is="icon" v-if="direction !== 'none'" :direction="direction" :color="getColor('hover', 'color')"/><slot/>
            </span>
        </template>
    </LinkHover>
</template>
<script>
import IconArrow from '@/components/IconArrow'
import IconDownload from '@/components/IconDownload'
import LinkHover from '@/components/animation/LinkHover'
const COLORS = {
    default: { color: '#636776', background: '#FFF' },
    hover:   { color: '#FFF', background: '#ff2b2a' }
}
export default {
    components: {
        IconArrow,
        IconDownload,
        LinkHover
    },
    props: {
        type: {
            type: String,
            default: 'a'
        },
        to: {
            type: Object | String,
            default: function () {
                return {}
            }
        },
        direction: {
            type: String,
            default: 'right',
            validator: function (direction) {
                return ['down', 'right', 'none'].indexOf(direction) > -1
            }
        },
        colors: {
            type: Object,
            default: function () {
                return {}
            },
            validator: function (colors) {
                let valid = true
                Object.keys(colors).forEach(key => {
                    const state = colors[key]
                    valid = valid && ['default', 'hover'].indexOf(key) > -1
                    Object.keys(state).forEach(place => {
                        valid = valid && ['color', 'background'].indexOf(place) > -1
                    })
                })
                return valid
            }
        },
        icon: {
            type: String,
            default: 'icon-arrow'
        }
    },
    computed: {
    },
    methods: {
        getStyle(state = 'default') {
            return {
                color: this.getColor(state, 'color'),
                background: this.getColor(state, 'background')
            }
        },
        getColor(state, place) {
            return (this.colors && this.colors[state] && this.colors[state][place]) ? this.colors[state][place] : COLORS[state][place]
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.cta
    border-radius: 4px
    height: auto
    cursor: pointer
    text-decoration: none
    display: inline-block
    /deep/ .default, /deep/ .hover
        text-decoration: none
        font-size: 17px
        font-weight: 500
        padding: 1.5em 4.4em
        display: inline-block
        @include media-breakpoint-down($sm)
            font-size: 11px
        .slim &
            margin-bottom: 0
            align-self: flex-end
    @include media-breakpoint-down($sm)
        svg
            width: 12px
            height: 10px
.is-dir-right
    svg
        left: 2.2em
        transform: translateX(-50%)
        position: absolute
.is-dir-down
    /deep/ .default, /deep/ .hover
        padding: 1.5em 4.4em 1.5em  1.5em
    svg
        right: 2.2em
        transform: translateX(50%) rotate(90deg)
        position: absolute
.is-dir-none
    &.cta
        /deep/ .default, /deep/ .hover
            padding: 1.5em 3.5em
</style>
